import { FieldArray, Form, Formik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Button from 'src/components/UI/Button';
import Breadcrumb from "src/components/Common/Breadcrumb";
import InputCom from "src/components/Common/Input";
import { useDispatch, useSelector } from "react-redux";
import { RootReducerState } from "src/store/reducers";
import { DealerCreateModel } from "src/models/pages/dealerModel";
import DeleteModal from "src/pages/Calendar/DeleteModal";
import { useToast } from "src/components/Common/ReactToaster";
import * as Yup from "yup";
import { ROUTER } from "src/constants/routes";
import { FieldModal } from "src/models/components/inputWrapperModel";
import ValidationPopup from "src/components/Common/ValidationMessage/ValidationPopup";
import TooltipMEL from "src/components/UI/Tooltip";
import DropdownInput from "src/components/UI/DropdownInput";
import { clearDeclarationMessage, createDeclarationFormLoading, getDeclarationFormByIdLoading, getManufacturerDropdownLoading, resetDeclarationMessage } from "src/store/actions";
import Camera from "./Scanner";
import { API } from "src/util/api";

const AddEditDeclarationForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { error, message, loading, manufacturerList } = useSelector(
    (state: RootReducerState) => state.DeclarationReducer
  );
  const { declarationFormDetails } = useSelector(
    (state: RootReducerState) => state.DeclarationReducer
  );
  
  
  useEffect(() => {
    const preloader: any = document.getElementById("preloader");
    if (loading) {
      preloader.style.display = "block";
    } else {
      preloader.style.display = "none";
    }
  }, [loading]);




  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [localFormFields, setLocalFormFields] = useState<FieldModal[]>([]);
  const [visible, setVisible] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    if (id) {
   dispatch(getDeclarationFormByIdLoading(id))
    } else {
    }
    dispatch(getManufacturerDropdownLoading())
    return () => {
      setVisible(false);
      dispatch(resetDeclarationMessage());
    };
    
  }, []);


  const preventSpecialChar = (event: any) => {
    if ((event.which >= 106 && event.which <= 111) || (event.which >= 187 && event.which <= 191) || event.which === 69) {
      event.preventDefault();
    }
  };


  useEffect(() => {
    if (error) {
      setVisible(true);
      setIsSubmitting(false)
      // showToast(error, { type: "error" })
    }
    if (message) {
      showToast(message, { type: "success" });
      setTimeout(() => {
        setIsSubmitting(false)
        dispatch(resetDeclarationMessage())
        navigate(ROUTER.DECLARATION_GRID);
      }, 500)

    }
  }, [error, message]);

  const hidePopup = () => {
    setVisible(false);
    dispatch(clearDeclarationMessage());
  };

  const dialogContainer = (error: any) => {
    return (
      <>
        <ValidationPopup error={error} visible={visible} onHide={hidePopup} />
      </>
    );
  };

  const post = (formValue: DealerCreateModel) => {
    debugger
    dispatch(createDeclarationFormLoading(formValue));
  };



  const update = (formValue: DealerCreateModel) => {
    dispatch(createDeclarationFormLoading(formValue, id));
  };


  const initialvalue = useMemo(()=>{
return {
    dcNumber: declarationFormDetails?.['dcNumber'] || "",
    type: declarationFormDetails?.['type'] ? declarationFormDetails?.['type'] : "",
    supplierName: declarationFormDetails?.["supplierName"] ? manufacturerList.find((item:any) => item.name === declarationFormDetails?.["supplierName"])?.id : "",
    supplierAddress: declarationFormDetails?.["supplierAddress"] || "",
    supplierContactPerson: declarationFormDetails?.["supplierContactPerson"] || "",
    supplierMobile: declarationFormDetails?.["supplierMobile"] || "",
    supplierEmail: declarationFormDetails?.["supplierEmail"] || "",
    supplierGSTNumber: declarationFormDetails?.["supplierGSTNumber"] || "",
    notes: declarationFormDetails?.["notes"] || "",
    dcFormDetailDto: declarationFormDetails?.dcFormDetails?.length > 0 ? declarationFormDetails?.dcFormDetails.filter((eachValue: any) => !eachValue.isDeleted).map((eachOrder:any) => {
      let data: any = {};
      data['dcFormId'] = id;
      data['defectSkus'] =eachOrder.defectSkus;
      data['jobNumber'] = eachOrder.jobNumber;
      data['vinNumber'] = eachOrder.vinNumber;
      data['totalPrice'] = eachOrder.totalPrice;
      data["remarks"] = eachOrder.remarks ? eachOrder.remarks : ""
      data["id"] = eachOrder.id ? eachOrder.id : ""
      return data;
    }) : [
      {
        dcFormId: id ? id : 0,
        defectSkus: "",
        jobNumber: "",
        vinNumber: "",
        totalPrice: "",
        remarks: "",
        id: 0,
      }
    ],
  };
  },[manufacturerList,declarationFormDetails]) 

  const handleSubmit = async (values: any) => {
    if (isSubmitting) return
    const submittedData: any = {
      "supplierName": values.supplierName ? manufacturerList?.find((item:any) => item.id === values.supplierName)?.name : "",
      "dcNumber": values.dcNumber,
      "type": values.type,
      "notes": values.notes,
      "supplierAddress": values.supplierAddress,
      "supplierMobile": values.supplierMobile,
      "supplierEmail": values.supplierEmail,
      "supplierGSTNumber": values.supplierGSTNumber,
      "dcFormDetailDto": values.dcFormDetailDto.map((eachValue: any) => {
        let data: any = { ...eachValue };
        data['dcFormId'] = id ? id : 0
        return data
      })
    };
    id ? update(submittedData) : post(submittedData);
    setIsSubmitting(true)
  };

  const validationSchema = Yup.object().shape({
    // dcNumber: Yup.string().required('DC Number is required'),
    type: Yup.string().required('Type is required'),
    // notes: Yup.string().required('Notes is required'),
    supplierName: Yup.string().required('Supplier Name is required'),
    // supplierAddress: Yup.string().required('Supplier Address is required'),
    supplierMobile: Yup.string()
    // .required('Supplier Mobile is required')
    .matches(/^\d{10}$/, "Mobile number must be 10 digits"),
    supplierEmail: Yup.string()
    // .required('Supplier Email is required')
    .email("Enter a valid email")
      .test("valid-email", "Enter a valid email", function (value) {
        if (!value) return true;
        return /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(value);
      }),
    supplierGSTNumber: Yup.string()
    // .required('Supplier GST Number is required')
    .test(
      'is-valid-gst',
      'Supplier GST Number is not valid',
      (value:any) => {
          if (!value || value.trim() === "") {
        return true; // ✅ Skip validation when empty
      }
        // Basic GST number validation (India)
        return /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][0-9A-Z][Z]{1}[0-9A-Z]{1}$/.test(value);
      }
    ),
    dcFormDetailDto: Yup.array().of(
      Yup.object().shape({
       

        defectSkus : Yup.string()
        .required('SKU Number is required')
        .test("unique-defectSkus", "SKU must be unique", function (value) {
          if (!value) return true;
          const { path, parent, options } = this;

          // Get the entire array
          const allItems = options?.context?.dcFormDetailDto || [];

          // Count how many times this SKU appears
          const count = allItems.filter(
            (item: any) => item.defectSkus?.trim() === value.trim()
          ).length;

          // If it appears more than once -> error on this field
          return count === 1;
        }),

        jobNumber : Yup.string()
        .required('Job Number is required'),
        vinNumber : Yup.string()
        .required('VIN Number is required')
        .min(17, 'VIN Number must be 17 characters')
        .max(17, 'VIN Number must be 17 characters'),
        totalPrice : Yup.number()
        .required('Total price is required'),
      })
    ),
  })

  const handleReset = (resetForm: any) => {
    resetForm(getEmptyInitialValues());
    if (id) {
      navigate(ROUTER.DECLARATION_GRID);
    }
  };
  const getEmptyInitialValues = () => {
    const initialValue = localFormFields?.reduce((acc: any, field: any) => {
      if (field.type !== 'checkbox') {
        acc[field.name] = '';
      } else {
        acc[field.name] = false;
      }
      return acc;
    }, {});
    return initialValue;
  };


  const handleAddContactDetails = (values: any, push: any, setFieldTouched: any) => {
    if (isContactDetailFilled(values)) {
      push({
        defectSkus: "",
        jobNumber: "",
        vinNumber: "",
        totalPrice: 0,
        remarks: "",
        id:0,
        dcFormId:id ? id : 0
      });
    } else {
      values.dcFormDetailDto?.forEach((_: any, index: number) => {
        setFieldTouched(`dcFormDetailDto[${index}].defectSkus`, true);
        setFieldTouched(`dcFormDetailDto[${index}].jobNumber`, true);
        setFieldTouched(`dcFormDetailDto[${index}].vinNumber`, true);
        setFieldTouched(`dcFormDetailDto[${index}].totalPrice`, true);
        setFieldTouched(`dcFormDetailDto[${index}].remarks`, true);
      })

    }

  };

  const isContactDetailFilled = (values: any) => {
    const partDetails = values.dcFormDetailDto || [];
    return partDetails.every((contact: any) => {
      const { id, dcFormId, remarks, ...fieldsExceptReOrderLevel } = contact;
      return Object.values(fieldsExceptReOrderLevel).every(
        (value: any) => value !== undefined && value !== null && value !== ""
      );
    });
  };


const [ apiLoading,setApiLoading]= useState(false)

  useEffect(() => {
    const preloader: any = document.getElementById("preloader");
    if (loading || apiLoading) {
      preloader.style.display = "block";
    } else {
      preloader.style.display = "none";
    }
  }, [loading,apiLoading]);


const supplierDropdown  = useMemo(()=>{
  return manufacturerList?.length >0 ? manufacturerList?.map((data:any)=>{
    return {
      label:data.name,
      value:data.id,
    }
  }) : []
},[manufacturerList])

 const handleSupplierChange = (e:any,setFieldValue:any)=>{
  const data = manufacturerList?.find((item:any) => item.id === e.target.value);
  if (data) {
    setFieldValue("supplierName", data?.id ? data?.id : "");
    setFieldValue("supplierAddress", data?.address ? data?.address : "");
    setFieldValue("supplierContactPerson", data?.id ? data?.phoneNumber : "");
    setFieldValue("supplierMobile", data?.phoneNumber ? data?.phoneNumber : "");
    setFieldValue("supplierEmail", data?.email ? data?.email : "");
    setFieldValue("supplierGSTNumber", data?.gstNo ? data?.gstNo : "");
  }
 }
  const [openScanner, setOpenScanner] = useState<boolean>(false); 
  const [indexNew, setIndex]=useState<any>(null)
   const openScannerHandler = (index: any, values: any, setFieldValue: any, push: any) => {
    setIndex(index)
    setOpenScanner(true);
  };
 const handleKeyPress =async (event: any, setFieldValue: any,index:any) => {
    if (event.which == 13 || event.which == 32) {
      event.preventDefault();
    }

    if (!event?.target?.value) return;

    let toScan = event.target.value;

    if (event.key === 'Enter' || event.key === "Tab") {
      try{
        debugger
        setApiLoading(true)
        let {data} = await API.checkSkuNumberForm(toScan)
        setFieldValue(`dcFormDetailDto[${index}].defectSkus`,toScan)
        setFieldValue(`dcFormDetailDto[${index}].jobNumber`,data?.jobNumber)
        setFieldValue(`dcFormDetailDto[${index}].vinNumber`,data?.vinNumber)
      }catch(err:any){
        showToast(err.message,{type:"error"})
        setFieldValue(`dcFormDetailDto[${index}].defectSkus`,"")
      }finally{
        setApiLoading(false)
      }
    }
  };
const onSkuFieldClick= async (event: any, setFieldValue: any,index:any)=>{
   let toScan = event.target.value;

    if (toScan) {
      try{
        setApiLoading(true)
        debugger
        let {data} = await API.checkSkuNumberForm(toScan)
        setFieldValue(`dcFormDetailDto[${index}].defectSkus`,toScan)
        setFieldValue(`dcFormDetailDto[${index}].jobNumber`,data?.jobNumber)
        setFieldValue(`dcFormDetailDto[${index}].vinNumber`,data?.vinNumber)
      }catch(err:any){
        showToast(err.message,{type:"error"})
        setFieldValue(`dcFormDetailDto[${index}].defectSkus`,"")
      }finally{
        setApiLoading(false)
      }
    }
}

  return (
    <div id="view-dealer">
      {visible && dialogContainer(error)}
      <DeleteModal
        show={deleteModal || false}
        showIcon={false}
        message="Are you sure want to delete this contact"
        onDeleteClick={() => {
          // deleteContact
        }}
        onCloseClick={() => {
          setDeleteModal(false);
        }}
      />
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title="Delivery Challan"
            titlePath={ROUTER.DECLARATION_GRID}
            breadcrumbItem={id ? "Edit Delivery Challan" : "Create Delivery Challan"}
          />
          <Row>
            <Card>
              <CardBody>
                <React.Fragment>
                  <Formik onSubmit={handleSubmit} initialValues={initialvalue} validationSchema={validationSchema} enableReinitialize >
                    {({ values, handleChange, touched, errors, handleBlur, resetForm, reset, setFieldValue, setFieldTouched, ...rest }: any) => {
                      return (
                        <Form onChange={handleChange}>
                          <Row>
                            <Col lg={3} className="mb-2">
                              <InputCom
                                labelName="DC Number"
                                inputclassName="form-control"
                                labelClassName="form-Label"
                                type="text"
                                name="dcNumber"
                                disabled={true}
                                onBlur={handleBlur}
                                value={values.dcNumber}
                                onChange={handleChange}
                                isRequired={false}
                                invalid={
                                  touched["dcNumber"] && errors["dcNumber"]
                                    ? true
                                    : false
                                }
                              />
                            </Col>
                            <Col lg={3} className="mb-2">
                              <DropdownInput
                                options={[{label:"Returnable",value:"R"},{label:"Non Returnable",value:"NR"}]}
                                name="type"
                                label="Type"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                required={true}
                                value={values.type}
                                disabled={id ? true : false}
                                invalid={
                                  touched["type"] && errors["type"]
                                    ? true
                                    : false
                                } />
                            </Col>
                            <Col lg={3} className="mb-2">

                              <DropdownInput
                                options={supplierDropdown}
                                name="supplierName"
                                label="Supplier Name"
                                onChange={(e:any)=>{
                                  handleChange(e)
                                  handleSupplierChange(e,setFieldValue)
                                }}
                                onBlur={handleBlur}
                                required={true}
                                value={values.supplierName}
                                invalid={
                                  touched["supplierName"] && errors["supplierName"]
                                    ? true
                                    : false
                                } />
                            </Col>
                            <Col lg={3} className="mb-2">
                             <InputCom
                                labelName="Supplier Address"
                                inputclassName="form-control"
                                labelClassName="form-Label"
                                type="textarea"
                                name="supplierAddress"
                                onBlur={handleBlur}
                                value={values.supplierAddress}
                                onChange={handleChange}
                                isRequired={false}
                                invalid={
                                  touched["supplierAddress"] && errors["supplierAddress"]
                                    ? true
                                    : false
                                }
                              />
                            </Col>
                            <Col lg={3} className="mb-2">
                              <InputCom
                                labelName="Supplier Mobile"
                                inputclassName="form-control"
                                labelClassName="form-Label"
                                type="text"
                                name="supplierMobile"
                                onBlur={handleBlur}
                                value={values.supplierMobile}
                                onChange={handleChange}
                                isRequired={false}
                                invalid={
                                  touched["supplierMobile"] && errors["supplierMobile"]
                                    ? true
                                    : false
                                }
                              />
                            </Col>
                            <Col lg={3} className="mb-2">
                              <InputCom
                                labelName="Supplier Email"
                                inputclassName="form-control"
                                labelClassName="form-Label"
                                type="text"
                                name="supplierEmail"
                                onBlur={handleBlur}
                                value={values.supplierEmail}
                                onChange={handleChange}
                                isRequired={false}
                                invalid={
                                  touched["supplierEmail"] && errors["supplierEmail"]
                                    ? true
                                    : false
                                }
                              />
                            </Col>
                            <Col lg={3} className="mb-2">
                              <InputCom
                                labelName="Supplier GST Number"
                                inputclassName="form-control"
                                labelClassName="form-Label"
                                type="text"
                                name="supplierGSTNumber"
                                onBlur={handleBlur}
                                value={values.supplierGSTNumber}
                                onChange={handleChange}
                                isRequired={false}
                                invalid={
                                  touched["supplierGSTNumber"] && errors["supplierGSTNumber"]
                                    ? true
                                    : false
                                }
                              />
                            </Col>
                            <Col lg={3} className="mb-2">
                              <InputCom
                                labelName="Notes"
                                inputclassName="form-control"
                                labelClassName="form-Label"
                                type="textarea"
                                name="notes"
                                onBlur={handleBlur}
                                value={values.notes}
                                onChange={handleChange}
                                isRequired={false}
                                invalid={
                                  touched["notes"] && errors["notes"]
                                    ? true
                                    : false
                                }
                              />
                            </Col>
                          </Row>

                          <Row>
                            <hr />
                            <Col lg={12} className="dealer-title-header">
                              <div>Add Sku</div>
                            </Col>
                           {openScanner &&  <Camera visible={openScanner} onHide={() => setOpenScanner(false)} allValue={setFieldValue} setOpenScanner={setOpenScanner} index={indexNew}/>}
                            <FieldArray name="dcFormDetailDto">
                              {({ insert, remove, push }) => (
                                <div >
                                  {values.dcFormDetailDto?.length > 0 &&
                                    values.dcFormDetailDto.map(
                                      (value: any, index: any) => {
                                        const isLastContact = index === values.dcFormDetailDto?.length - 1;
                                        return <div key={index}>

                                          <Row>
                                            <Col lg={2} className="mb-2">

                                              <InputCom
                                                labelName="SKU Number"
                                                inputclassName="form-control"
                                                labelClassName={`form-Label ${index == 0 ? "" : "d-sm-none"} label-noWrap`}
                                                type="text"
                                                cameraIcon={true}
                                                camerClick={() => openScannerHandler(index, values, setFieldValue, push)}
                                                camerIconDisable={value.id}
                                                name={`dcFormDetailDto.${index}.defectSkus`}
                                                disabled={value.id}
                                                onKeyDown={(event: any) => {
                                                  handleKeyPress(event, setFieldValue, index);
                                                }}
                                                onBlur={(event) => {
                                                  handleBlur(event);
                                                  onSkuFieldClick(event,setFieldValue,index)
                                                }
                                                }
                                                value={value.defectSkus}
                                                onChange={handleChange}
                                                isRequired={true}
                                                loading={loading}
                                                invalid={
                                                  (touched.dcFormDetailDto?.[index]?.defectSkus &&
                                                    errors.dcFormDetailDto?.[index]?.defectSkus && !loading)
                                                    ? true
                                                    : false
                                                }
                                              />
                                            </Col>
                                            <Col lg={2} className="mb-2">
                                              <InputCom
                                                labelName="Job Number"
                                                inputclassName="form-control"
                                                labelClassName={`form-Label ${index == 0 ? "" : "d-sm-none"}`}
                                                type="text"
                                                name={`dcFormDetailDto[${index}].jobNumber`}
                                                onBlur={handleBlur}
                                                onChange={(e) => { handleChange(e)
                                                }}
                                                isRequired={true}
                                                value={value.jobNumber || ""}
                                                disabled={true}
                                                invalid={
                                                  touched.dcFormDetailDto?.[
                                                    index
                                                  ]?.jobNumber &&
                                                    errors.dcFormDetailDto?.[index]
                                                      ?.jobNumber
                                                    ? true
                                                    : false
                                                }
                                              />
                                            </Col>

                                            <Col lg={2} className="mb-2">
                                              <InputCom
                                                labelName="Vin Number"
                                                inputclassName="form-control"
                                                labelClassName={`form-Label ${index == 0 ? "" : "d-sm-none"}`}
                                                type="text"
                                                name={`dcFormDetailDto[${index}].vinNumber`}
                                                onBlur={handleBlur}
                                                onChange={(e:any)=>{
                                                  handleChange(e)
                                                }}
                                                isRequired={true}
                                                value={value.vinNumber}
                                                invalid={
                                                  touched.dcFormDetailDto?.[
                                                    index
                                                  ]?.vinNumber &&
                                                    errors.dcFormDetailDto?.[index]
                                                      ?.vinNumber
                                                    ? true
                                                    : false
                                                }
                                              />
                                            </Col>
                                            <Col lg={2} className="mb-2">
                                              <InputCom
                                                labelName="Total Price"
                                                inputclassName="form-control"
                                                labelClassName={`form-Label ${index == 0 ? "" : "d-sm-none"}`}
                                                type="number"
                                                min={0}
                                                name={`dcFormDetailDto[${index}].totalPrice`}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                isRequired={true}
                                                value={value.totalPrice}
                                                invalid={
                                                  touched.dcFormDetailDto?.[
                                                    index
                                                  ]?.totalPrice &&
                                                    errors.dcFormDetailDto?.[index]
                                                      ?.totalPrice
                                                    ? true
                                                    : false
                                                }
                                              />
                                            </Col>

                                            <Col lg={2} className="mb-2">
                                              <div className="d-flex align-items-end">
                                                <div className="d-block parts-inbound-width">
                                                  <InputCom
                                                labelName="Remarks"
                                                inputclassName="form-control"
                                                labelClassName={`form-Label ${index == 0 ? "" : "d-sm-none"}`}
                                                type="text"
                                                min={0}
                                                name={`dcFormDetailDto[${index}].remarks`}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                isRequired={false}
                                                value={value.remarks}
                                                invalid={
                                                  touched.dcFormDetailDto?.[
                                                    index
                                                  ]?.remarks &&
                                                    errors.dcFormDetailDto?.[index]
                                                      ?.remarks
                                                    ? true
                                                    : false
                                                }
                                              />
                                                </div>
                                                <div className="justify-content-center remove-tooltip-margin">
                                                  {values.dcFormDetailDto.length > 1 && <TooltipMEL title="Remove part" position="bottom">


                                                    <i className="fas fa-times-circle color-red"
                                                      onClick={() => {
                                                        if(value.id){

                                                          API.deleteChallanSku(value.id)
                                                            .then(() => {
                                                              showToast("Sku removed successfully", { type: "success" });
                                                              remove(index);
                                                            })
                                                            .catch((err: any) => {
                                                              showToast(err.message, { type: "error" });
                                                            });
                                                        }else{
                                                          remove(index)
                                                        }
                                                      }
                                                      }>
                                                    </i>

                                                  </TooltipMEL>}
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                          <div className="multiadd-container">
                                            {isLastContact &&
                                              <div className="add-btn-container" onClick={() => { handleAddContactDetails(values, push, setFieldTouched); }}>
                                                <TooltipMEL title="Add Parts" position='bottom'>
                                                  <i className="fas fa-plus-circle"></i><span>Add</span>
                                                </TooltipMEL>
                                              </div>
                                            }
                                          </div>
                                        </div>;
                                      }
                                    )}
                                  <hr className="mt-1" />
                                </div>
                              )}
                            </FieldArray>
                          </Row>
                          <div className="d-flex justify-content-end mt-2">
                            {/* <TooltipMEL title={id ? "Cancel" : "Reset The Form"} position='top'> */}
                            <Button
                              className="secondary-btn me-2"
                              label={id ? "Cancel" : "Reset"}
                              type="button"
                              onClick={() => handleReset(resetForm)}
                            />

                            <Button
                              className="btn-primary me-2 btn-primary-shadow"
                              label={id ? "Update Delivery Challan" : "Create Delivery Challan"}
                              type="submit"
                            />
                            {/* </TooltipMEL> */}
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                </React.Fragment>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default AddEditDeclarationForm;
